module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "brandname"
  }, [_vm._v("Flipcards")]), _vm._v(" "), _c('h1', [_vm._v("Digital Index Cards")]), _vm._v(" "), _c('p', [_vm._v("Study effectively with online Index Cards, synced in real time across all your devices.")]), _vm._v(" "), _c('div', {
    staticClass: "ctas"
  }, [_c('router-link', {
    staticClass: "button acc",
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("Sign up")]), _vm._v(" "), _c('router-link', {
    staticClass: "button prim",
    attrs: {
      "to": {
        name: 'signin'
      }
    }
  }, [_vm._v("Sign in")])], 1), _vm._v("\n    Or "), _c('a', {
    staticClass: "local-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signInLocally.apply(null, arguments)
      }
    }
  }, [_vm._v("sign In locally")]), _vm._v(" and add synchronization later.\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f0455de","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Frontpage.vue
// module id = 283
// module chunks = 1